import { CaptionedBlockComponent } from '@blocksuite/affine-components/caption';
import type { ColumnBlockModel } from '@blocksuite/affine-model';
import { focusTextModel } from '@blocksuite/affine-rich-text';
import { html } from 'lit';

import { columnContainerStyles, columnHostStyles } from './styles.js';

/**
 * A single column. Clicking an empty column creates a paragraph so the
 * column is never a dead zone.
 */
export class ColumnBlockComponent extends CaptionedBlockComponent<ColumnBlockModel> {
  private readonly _handleBlockClick = (event: MouseEvent) => {
    if (this.model.children.length > 0) return;
    event.stopPropagation();
    const paragraphId = this.store.addBlock('affine:paragraph', {}, this.model);
    focusTextModel(this.std, paragraphId);
  };

  override connectedCallback() {
    super.connectedCallback();
    this.classList.add(columnHostStyles);
  }

  override renderBlock() {
    return html`
      <div class="${columnContainerStyles}" @click=${this._handleBlockClick}>
        ${this.renderChildren(this.model)}
      </div>
    `;
  }

  override accessor useZeroWidth = true;
}

declare global {
  interface HTMLElementTagNameMap {
    'affine-column': ColumnBlockComponent;
  }
}
